import { render, staticRenderFns } from "./KBadge.vue?vue&type=template&id=18a4f1f0&scoped=true&"
import script from "./KBadge.vue?vue&type=script&lang=js&"
export * from "./KBadge.vue?vue&type=script&lang=js&"
import style0 from "./KBadge.vue?vue&type=style&index=0&id=18a4f1f0&scoped=true&lang=css&"
import style1 from "./KBadge.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a4f1f0",
  null
  
)

export default component.exports